import { useGuaziSiteConfig } from '@/hooks/guaziUseSiteConfig';

export default function GuaziDownloadHero() {
  const { config } = useGuaziSiteConfig();

  const platforms = [
    {
      key: 'android',
      icon: 'ri-android-line',
      name: 'Android 版',
      desc: '适用于绝大多数安卓手机，安装包轻量，兼容性好，下载即装。',
      href: config.download.android,
      tone: 'primary',
      tag: '推荐',
    },
    {
      key: 'ios',
      icon: 'ri-apple-line',
      name: 'iOS 版',
      desc: '适配 iPhone 与 iPad，瓜子影视iOS官网最新下载安装一步到位。',
      href: config.download.ios,
      tone: 'accent',
      tag: '苹果',
    },
    {
      key: 'harmony',
      icon: 'ri-smartphone-line',
      name: 'HarmonyOS 版',
      desc: '原生适配鸿蒙系统，运行流畅更省电，多设备协同体验更佳。',
      href: config.download.harmony,
      tone: 'secondary',
      tag: '鸿蒙',
    },
    {
      key: 'tv',
      icon: 'ri-tv-2-line',
      name: 'TV 版',
      desc: '瓜子影视TV版2026官方最新版下载，大屏观影更沉浸，遥控操作更顺手。',
      href: config.download.tv,
      tone: 'primary',
      tag: '大屏',
    },
  ];

  const toneMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700',
    accent: 'bg-accent-100 text-accent-700',
    secondary: 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section className="relative w-full overflow-hidden bg-background-50 pt-[88px] md:pt-[100px]">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="/images/guazi-download-bg.jpg"
          alt="瓜子影视下载页背景"
          title="瓜子影视APP下载官网"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/90 via-white/70 to-background-50" />
      </div>

      <div className="relative w-full px-4 md:px-6 pb-16 md:pb-20">
        <div className="text-center max-w-3xl mx-auto pt-8 md:pt-12 guazi-fade-up">
          <div className="flex items-center justify-center mb-5">
            <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg overflow-hidden shrink-0">
              <img
                src="/images/guazi-app-icon.png"
                alt="瓜子影视软件图标"
                title="瓜子影视APP下载官网"
                className="w-full h-full object-cover"
              />
            </span>
          </div>

          <h1 className="font-heading font-extrabold text-3xl md:text-5xl text-foreground-950 tracking-tight">
            瓜子影视APP下载官网
          </h1>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-7">
            请选择你的设备平台，点击对应按钮即可获取瓜子影视安装包。Android、iOS、HarmonyOS 与瓜子影视TV版2026官方最新版下载均已就绪。
          </p>
        </div>

        {/* 平台下载卡片 */}
        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {platforms.map((p) => (
            <div
              key={p.key}
              className="flex flex-col bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors duration-200"
            >
              <div className="flex items-center justify-between">
                <span className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg ${toneMap[p.tone]}`}>
                  <i className={`${p.icon} text-2xl md:text-3xl`} />
                </span>
                <span className="px-2.5 py-1 bg-background-100 border border-background-200 rounded-full text-xs text-foreground-600 whitespace-nowrap">
                  {p.tag}
                </span>
              </div>
              <h2 className="mt-4 font-heading font-bold text-lg md:text-xl text-foreground-950">{p.name}</h2>
              <p className="mt-2 text-sm text-foreground-600 leading-6 flex-1">{p.desc}</p>
              <a
                href={p.href}
                className="mt-5 inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-primary-500 text-primary-950 text-sm font-bold rounded-md hover:bg-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-base" />
                立即下载
              </a>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-xs md:text-sm text-foreground-500">
          提示：下载后如提示“未知来源”，请在系统设置中允许安装即可。
        </p>
      </div>
    </section>
  );
}